import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import type { ITransactionRefund } from "@app/dashboard/types/innerLayout/transactions";

export const refundTransaction = ({
  transactionId,
  amount,
  productsIds,
  refundReason,
  pin
}: ITransactionRefund) => {

  const params = {
    transaction_id: transactionId,
    amount_cents: amount,
    product_ids: productsIds,
    refund_reason: refundReason,
    pin: pin,
  };

  // Remove falsy values
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => Boolean(value))
  );

  return axiosPrivate.post(`/dashboard/api/v1/refund`, filteredParams);
};

export const halanRefundSubmitOtp = ({
  otp,
  transactionId,
  authToken
}: {
  otp: string;
  transactionId: number;
  authToken?: string;
}) => {

  const params = {
    otp: otp,
    transaction_id: transactionId,
    auth_token: authToken
  };

  return axiosPrivate.post(`/dashboard/api/v1/halan_refund`, params);
};